<script>
  let activeTab = 'about';
</script>

<div class="info-tabs">
  <button
    class="browse-tab"
    class:active={activeTab === 'about'}
    on:click={() => activeTab = 'about'}
  >About</button>
  <button
    class="browse-tab"
    class:active={activeTab === 'privacy'}
    on:click={() => activeTab = 'privacy'}
  >Privacy</button>
</div>

{#if activeTab === 'about'}
  <div class="info-body">
    <div class="info-section">
      <h2 class="info-heading">What is this?</h2>
      <p class="info-text">
        I'm tired of my spreadsheet so I made this site.
        Log/review your gigs and shit.
        Heck - I'll even add a custom review functionality in next version, review your grandmas soup or that cigar for all I care
      </p>
    </div>

    <div class="info-section">
      <h2 class="info-heading">Who is it for?</h2>
      <p class="info-text">
        The creator of this site, if you find it useful that makes the creator happeh.
      </p>
    </div>

    <div class="info-section">
      <h2 class="info-heading">Contact</h2>
      <p class="info-text">
        Bug-reporting, feature requests or accepting invites DM @deathmetaldiary at instagram
      </p>
    </div>
  </div>

{:else}
  <div class="info-body">
    <div class="info-section">
      <h2 class="info-heading">No cookies</h2>
      <p class="info-text">
        Fuck those cookies man - I don't care what you do
      </p>
    </div>

    <div class="info-section">
      <h2 class="info-heading">Authentication</h2>
      <p class="info-text">
        Login is handled via HttpOnly JWT tokens. The token is stored in a
        browser cookie and transmitted over HTTPS only. It is never accessible
        to JavaScript running in the browser.
      </p>
    </div>


    <div class="info-section">
      <h2 class="info-heading">Your data</h2>
      <p class="info-text">
        If you want stuff deleted - dm me on @deathmetaldiary on instagram with your username
      </p>
    </div>
  </div>
{/if}

<style>
  /* Tab bar — reuses the same pattern as .browse-tabs in App.svelte */
  .info-tabs {
    display: flex;
    border-bottom: 1px solid #1e3d00;
    background: #0a0a0a;
    position: sticky;
    top: 0;
    z-index: 50;
    box-shadow: 0 2px 12px rgba(0,0,0,0.5);
  }
  .browse-tab {
    flex: 1;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;
    color: #2a5200;
    cursor: pointer;
    font-family: 'Rajdhani', sans-serif;
    font-weight: 700;
    font-size: 0.6rem;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    padding: 0.75rem 0.5rem;
    transition: color 0.15s, border-color 0.15s;
  }
  .browse-tab:hover { color: #4a7c00; }
  .browse-tab.active { color: #6db800; border-bottom-color: #6db800; }

  /* Content */
  .info-body {
    padding: 1.5rem 1rem 6rem;
    display: flex;
    flex-direction: column;
    gap: 1.75rem;
    animation: fadeUp 0.25s ease forwards;
  }
  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .info-section {
    border-left: 3px solid #1e3d00;
    padding-left: 0.85rem;
  }

  .info-heading {
    font-family: 'Rajdhani', sans-serif;
    font-weight: 700;
    font-size: 0.6rem;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    color: #6db800;
    margin-bottom: 0.5rem;
  }

  .info-text {
    font-family: 'Rajdhani', sans-serif;
    font-weight: 400;
    font-size: 0.9rem;
    line-height: 1.6;
    color: #888;
    letter-spacing: 0.02em;
  }

  .info-link {
    color: #3a6b00;
    text-decoration: none;
    border-bottom: 1px solid #1e3d00;
    transition: color 0.15s, border-color 0.15s;
  }
  .info-link:hover {
    color: #6db800;
    border-bottom-color: #3a6b00;
  }
</style>
